import { AuditLiveMention, AuditLiveMentionConfidence } from '@mi-front/core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { apiClient } from '../../../../../api';

// FIXME: should allow only ID, needs change in API
export function useAuditMention(stationId: string, id: string) {
  const queryClient = useQueryClient();

  const [rejected, setRejected] = useState(false);

  const result = useQuery({
    queryKey: ['mentions', id],

    queryFn: () => {
      return apiClient.audit.getMentionMatch({
        stationId,
        id,
      });
    },

    enabled: !rejected,
  });

  const confidenceMutation = useMutation({
    mutationFn: (confidence: AuditLiveMentionConfidence) => {
      return apiClient.audit.updateLiveMentionMatch({
        stationId,
        id,
        data: {
          confidence,
        },
      });
    },
    onMutate: async (confidence) => {
      queryClient.setQueryData(['mentions', id], (old: any) => ({
        ...old,
        confidence,
      }));

      if (confidence === AuditLiveMentionConfidence.REJECTED) {
        setRejected(true);

        queryClient.setQueryData<AuditLiveMention[]>(['mentions-active'], (current) => {
          return current?.filter((m) => m.id !== id) || [];
        });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['audit-mentions-matches'] });
    },
  });

  return {
    ...result,
    confidenceMutation,
  };
}
